<template>
  <!--选择文件类型-->
  <select-dialog
    v-if="selectFileType"
    ref="selectDialog"
    :title="title"
    :row-data="rowData"
    :column-defs="singleColumnDefs"
    :filter-keys="['name', 'documentTypeUuidStr']"
    :value="fileTypeTemplateUuid"
    :event-name="eventName"
    :display-name-field="displayNameField"
    :show-office="true"
    @change="changeTrigger"
    @selected="selectedHandle"
  />
  <!--选择模板-->
  <select-multi-dialog
    v-else
    ref="selectMultiDialog"
    :title="title"
    :row-data="rowData"
    :column-defs="multiColumnDefs"
    :filter-keys="['name', 'documentTypeUuidStr']"
    :value="templateUuids"
    :event-name="eventName"
    :display-name-field="displayNameField"
    :show-office="true"
    @change="changeTrigger"
  />
</template>

<script>
import { INSTRUCTION_TEMPLATE_TYPE_MAP, SE } from '@/class/cargo/model/parameters/SystemConstants'
import SelectDialog from '@/components/SelectDialog'
import SelectMultiDialog from '@/components/SelectMultiDialog'

export default {
  name: 'TemplateManagementDialog',
  components: { SelectDialog, SelectMultiDialog },
  props: {
    lob: {
      type: String,
      default: () => SE.code
    },
    documentTypeUuid: { // 选中的文件类型
      type: String,
      default: () => ''
    },
    templateUuids: { // 选中的模板
      type: Array,
      default: () => []
    },
    templates: { type: Array, default: () => [] }, //
    selectFileType: { // true-选择文件类型 false-选择模板
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      rowData: [],
      columnDefs: [
        {
          headerName: this.$t('SystemMaintenance.AdditionalOutputAssociatedTemplate'),
          field: 'coverTemplateUuidStr',
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.FileClassification'),
          field: 'documentTypeUuidStr',
          width: 100
        }, {
          headerName: this.$t('SystemMaintenance.TemplateFileCloudStorageID'),
          cellRenderer: params => {
            if (params.data.engine !== 1 && params.data.engine !== 2) {
              return params.data.documentId
            }
            if (params.data.documentId) {
              return `<u onclick="document.templateManage.editReport('${params.data.uuid}')" style="cursor:pointer">${params.data.documentId}</u>`
            } else {
              return `<u onclick="document.templateManage.createReport('${params.data.uuid}')" style="cursor:pointer">${this.$t('SystemMaintenance.CreateTemplate')}</u>`
            }
          },
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.TemplateEngine'),
          field: 'engineStr',
          width: 100
        }, {
          headerName: this.$t('SystemMaintenance.FilterScript'),
          field: 'filter',
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.TemplateName'),
          field: 'name',
          width: 100
        }, {
          headerName: this.$t('SystemMaintenance.BranchSerialNumber'),
          field: 'officeIdStr',
          width: 200
        }, {
          headerName: this.$t('SystemMaintenance.Remark'),
          field: 'remarks',
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.TemplateFile'),
          field: 'templateFile',
          width: 150
        }, {
          headerName: this.$t('SystemMaintenance.TemplateSerialNumber'),
          field: 'templateId',
          width: 100
        }, {
          headerName: this.$t('SystemMaintenance.TemplateClass'),
          field: 'templateType',
          width: 100
        }, {
          headerName: this.$t('SystemMaintenance.TemplateUsage'),
          field: 'templateUsageStr',
          width: 100
        }
      ],
      eventName: '',
      displayNameField: '',
      fileTypeTemplate: {}
    }
  },
  computed: {
    fileTypeTemplateUuid() {
      return this.fileTypeTemplate ? this.fileTypeTemplate.uuid : ''
    },
    title() {
      return this.selectFileType ? this.$t('CargoMsg.Cargo_SelectPrintFileType') : this.$t('CargoMsg.Cargo_SelectPrintFileTemplate')
    },
    singleColumnDefs() { // 单选
      return [...this.columnDefs]
    },
    multiColumnDefs() { // 多选
      return [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        ...this.columnDefs
      ]
    }
  },
  watch: {
    selectFileType() {
      if (this.selectFileType) {
        this.displayNameField = 'documentTypeUuidStr'
      } else {
        this.displayNameField = 'name'
      }
      this.eventName = ''
      this.fileTypeTemplate = {}
      if (this.$refs.selectDialog) {
        this.$refs.selectDialog.onReset()
      }
      if (this.$refs.selectMultiDialog) {
        this.$refs.selectMultiDialog.onReset()
      }
    },
    documentTypeUuid() {
      if (!this.documentTypeUuid) {
        this.eventName = ''
        this.fileTypeTemplate = {}
        if (this.$refs.selectDialog) {
          this.$refs.selectDialog.onReset()
        }
        if (this.$refs.selectMultiDialog) {
          this.$refs.selectMultiDialog.onReset()
        }
      } else {
        const template = this.rowData.find(item => item.documentTypeUuid === this.documentTypeUuid)
        if (template) {
          this.eventName = template.documentTypeUuidStr
          this.fileTypeTemplate = template
        }
      }
    },
    templateUuids() {
      if (!this.templateUuids || this.templateUuids.length === 0) {
        this.eventName = ''
        this.fileTypeTemplate = {}
        if (this.$refs.selectDialog) {
          this.$refs.selectDialog.onReset()
        }
        if (this.$refs.selectMultiDialog) {
          this.$refs.selectMultiDialog.onReset()
        }
      }
    }
  },
  created() {
    this.rowData = []
    this.eventName = ''
    this.fileTypeTemplate = {}
    if (this.selectFileType) {
      this.displayNameField = 'documentTypeUuidStr'
    } else {
      this.displayNameField = 'name'
    }
    if (this.templates && this.templates.length > 0) {
      this.rowData = this.templates.filter(p => {
        return p.templateType && INSTRUCTION_TEMPLATE_TYPE_MAP.get(this.lob).indexOf(p.templateType.trim()) > -1
      })
      if (this.rowData && this.rowData.length > 0) {
        if (this.selectFileType) {
          if (this.documentTypeUuid) {
            const template = this.rowData.find(item => item.documentTypeUuid === this.documentTypeUuid)
            if (template) {
              this.eventName = template.documentTypeUuidStr
              this.fileTypeTemplate = template
            }
          }
        } else {
          if (this.templateUuids && this.templateUuids.length > 0) {
            const templates = this.rowData.filter(item => this.templateUuids.indexOf(item.uuid) > -1)
            if (templates) {
              this.eventName = templates.map(p => p.name).join(',')
            }
          }
        }
      }
    }
  },
  methods: {
    changeTrigger(data) {
      this.$emit('change', data)
    },
    selectedHandle(data) {
      if (!data.documentTypeUuid) {
        this.$message.error(this.$t('CargoMsg.Cargo_SelectPrintFileTypeTip'))
      }
    }
  }
}
</script>
